const sendMessageToAI = async (message) => {
  try {
    const response = await fetch("https://theagencybazaar.com/api/ai/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message,
      }),
    });

    const data = await response.json();

    if (!data.success) {
      throw new Error("AI response failed");
    }

    return data.response;
  } catch (error) {
    console.error(error);

    return "Sorry, something went wrong.";
  }
};

export default sendMessageToAI;


